<template>
    <div class="container_title">
        <h2 class="block-title">{{ title }}</h2>
    </div>
</template>
<script setup lang="ts">
defineProps<{ title: string }>();
</script>
<style lang="scss" scoped>
.container_title {
    position: relative;
}
.block-title {
    color: var(--main-black-2-b-2-b-2-b, #2b2b2b);
    font-family: Roboto;
    font-size: 3rem;
    font-style: normal;
    font-weight: 600;
    line-height: 3.75rem; /* 125% */
    margin-bottom: unset;
}
.container_title::before {
    content: '-';
    width: 100%;
    left: calc(-100% - 1.75rem);
    height: 1px;
    position: absolute;
    top: 50%;
    background: #2b2b2b;
}
.two-row-title::before {
    top: 25%;
}

@media (max-width: 1000px) {
    .block-title {
        font-size: 30px;
        line-height: 38px;
        margin-left: calc(5rem - 0.75rem); //0,75 - guutter boostrap
    }
    .container_title::before {
        left: calc(-100% + 5rem - 1.75rem);
    }
}
@media (max-width: 768px) {
    .block-title {
        font-weight: 600;
        font-size: 26px;
        line-height: 36px;
        margin-left: 0;
    }
    .container_title::before {
        display: none;
        content:"";
    }
}
</style>
